import { render, staticRenderFns } from "./BasicDropdownMenu.vue?vue&type=template&id=c4a97826&scoped=true"
import script from "./BasicDropdownMenu.vue?vue&type=script&lang=js"
export * from "./BasicDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./BasicDropdownMenu.vue?vue&type=style&index=0&id=c4a97826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a97826",
  null
  
)

export default component.exports